<template>

<app-input-wrapper :slim="slim" :stacked="true" :value="value" :note="note" :label="label" :errored="errored" :class="{'is-errored': errored}">

	<input type="file" ref="upload" v-on:change="onFileSelected" class="input-hidden" />

	<div class="images">

		<div class="images-item" :style="{backgroundImage: 'url(' + image + ')'}" v-for="(image, index) in value" :key="index" v-tooltip="'Click to remove'" v-on:click="onImageClick(index)"></div>

		<div class="images-item is-add" :class="{'is-loading': is.loading}" v-on:click="onUploadClick" v-tooltip="'Upload photo'"><i class="fa fa-plus-circle"></i></div>

	</div>

</app-input-wrapper>

</template>

<script>

import mixinInput from '@/mixin/input.js'

export default {

	mixins: [mixinInput],

	data: function() {

		return {
			is: {
				loading: false
			}
		}

	},

	methods: {

		onUploadClick: function() {

			this.$refs.upload.click()

		},

		onImageClick: function(index) {

			this.value.splice(index, 1)

		},

		onFileSelected: function(e) {

			this.is.loading = true

			var file = e.target.files[0]
			var reader = new FileReader()
			reader.readAsDataURL(file)

			reader.onload = function() {

				this.$emit('change', reader.result)

				this.value.push(reader.result)

				this.is.loading = false

			}.bind(this)

		}

	}

}

</script>

<style scoped>

.images {
	width: 100%;
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
}

.images-item {
	width: 48px;
	margin: 0px 4px 4px 0px;
	height: 48px;
	border: 1px solid var(--color-grey-light);
	border-radius: 4px;
	background-size: cover;
	background-position: 50% 50%;
	background-repeat: no-repeat;
}

.images-item.is-add {
	color: var(--color-blue-light);
	text-align: center;
	line-height: 46px;
	background-size: auto;
	cursor: pointer;
	font-size: 20px;
}

.images-item.is-add.is-loading {
	pointer-events: none;
	background-image: url(~@/assets/app.load.gif);
}

.images-item.is-add.is-loading > * {
	opacity: 0;
}

.is-desktop .images-item:hover {
	border-color: var(--color-blue-dark);
	background-color: var(--color-blue-dark);
}

.is-desktop .images-item.is-add:hover {
	color: #fff;
}

.input-hidden {
	display: none;
}

</style>